import React, { Component } from "react";
import TableGrid from "../../components/UI/TableGrid";
import { ToastContext } from "../../context/ToaxtContext";
import ReactDOM from "react-dom";

import {
  encryptString,
  formatPhoneNumberUS,
  isSet,
} from "../../utils/commonUtils";
import Buttons from "../../components/UI/Buttons";
import WithRoutify from "../../hoc/WithRoutify";
import EmployeeService from "../../services/EmployeeService";
import withReduxState from "../../hoc/wReduxState";
import AddEmployee from "./AddEmployee";
import { genderOptions } from "../../utils/constant";
import EmployeeDetails from "./EmployeeDetails";
import EmployeeFilter from "./EmployeeFilter";
import AddDependents from "./AddDependents";
import FormInputs from "../../components/UI/FormInputs";
import PERMISSIONS from "../../utils/AclPermissions";
import { acl_check } from "../../utils/aclUtils";
import SendInviteLinkModal from "../../components/Modal/sendInviteLinkModal";
import ScanbarCodePopup from "./ScanbarCodePopup";
import GlobalSearch from "../../components/Layouts/NewAppLayout/GlobalSearch/GlobalSearch";
import SendTaskModal from "../../components/Modal/SendTaskModal";
import MergeChartsContainer from "./MergeCharts/MergeChartsContainer";
import MergeHistoryViewer from "./MergeCharts/components/MergeHistoryViewer";
import CloneToCompanyModal from "../../components/Modal/CloneToCompanyModal";
import AuditLogPopup from "../../components/Modal/AuditLogPopup";
import Modal from "react-bootstrap/Modal";
import { connect } from "react-redux";
import { setActiveIds, setSelectedAllRecords, clearCbState } from "../../store/GlobalFilterSlice";


class EmployeeList extends Component {
  static contextType = ToastContext;
  constructor(props) {
    super(props);
    // Initialize state or bind methods if needed
    const tableHeaders = [
      {
        label: "",
        key: "isActive",
        type: "checkBox",
        name: "ALL",
        changeHandler: this.checkBoxchangeHandler,
      },
     
      {
        label: "First Name",
        key: "first_name",
        type: "",
        inputType: "TextInput",
      },
      {
        label: "Last Name",
        key: "last_name",
        type: "",
        inputType: "TextInput",
      },
      { label: "DOB", key: "dob", type: "", inputType: "Date" },
      {
        label: "Gender",
        key: "gender",
        type: "",
        inputType: "SelectList",
        options: genderOptions,
      },
      { label: "Cell Number", key: "phone", inputType: "Phone" },
      { label: "Company", key: "company" },
      { label: "Status", key: "status" },
      { label: "Action", key: "action", type: "Actions" },
      // Add more columns as needed
    ];
    this.state = {
      addEmployeeAutoFillData:{},
      filters: {
        first_name: "",
        last_name: "",
        gender: "",
        company_id: "",
        dob: "",
        patient_id: "",
        phone: "",
        patient_id: "",
        identification_type: "",
        identification_number: "",
        clinic_id: "",
        booking_id: "",
        pre_registration_code: "",
      },
      tableRecords: {
        tableHeaders: tableHeaders,
        tableRows: {
          data: [],
        },
        pagination:{
          page:1,
          perPage:25,
          totalRecords:0,
          sort_by:'',
          sort_order:'',
        },
      },
      
      formDataInEdit: {},
      activeEditId: null,
      // Your state variables go here
      isModelOpen: false,
      detailViewId: null,
      isDetailViewOpen: false,
      isDependentModelOpen:false,
      inviteModalOpen:false,
      scanBarcodeModalOpen:false,
      mergeChartsModalOpen: false,
      mergeHistoryModalOpen: false,
      mergeHistoryEmployeeId: null,
      // Multi-profile: clone modal (opened from list toolbar).
      cloneToCompanyModalOpen: false,
      filterOpen: false,
      isActiveDataLoaded:true,
      company_id:null,
      clinic_id:null,
      showAuditLogModal: false,
      selectedAuditLogUserId: null,
    };
  }

  componentDidMount() {
    this.fetchEmployeeList();
    // Code to run after the component has mounted
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.globalFilter.Chart!==this.props?.globalFilter?.Chart) {
      this.fetchEmployeeList();
    }
  }

  componentWillUnmount() {
    // Code to run before the component is unmounted
    document.body.classList.remove('filterOpened')
  }

  handlePatientSelect = (employeeData) => {
    // Only navigate for employer_admin role
    if (this.props.profile?.role === 'employer_admin' && employeeData) {
      const patientParams = encryptString({
        patientName: `${employeeData.name || ''}`,
        company_id: employeeData.company_id || '',
        company_assigned: employeeData.company_assigned || '',
        employee_id: employeeData.id || employeeData.employee_id,
      });
      
      if (acl_check(this.props.profile.permissions, PERMISSIONS.VISITS.LIST)) {
        // Navigate to employer-employee container instead of common employee container
        const employeeId = employeeData.id || employeeData.employee_id;
        // Use navigate from WithRoutify if available, otherwise use history
        if (this.props.navigate) {
          this.props.navigate(`/employer-employee/visit-history/${employeeId}/${patientParams}`);
        } 
      }
    }
  }

  handleEvent = () => {
    // Handler for events (e.g., button click)
  };

  viewMergeHistory = (employeeId) => {
    this.setState({
      mergeHistoryModalOpen: true,
      mergeHistoryEmployeeId: employeeId,
    });
  };

  /**
   * Opens add-to-another-company modal. Patient is selected inside the modal.
   * Backend policy allows Global Admin / Org Admin only.
   */
  openAddToAnotherCompanyHandler = () => {
    const role = String(this.props.profile?.role || "").toLowerCase();
    if (role !== "global_admin" && role !== "organization_admin") {
      this.props.Toast?.error?.(
        "Only Global Admin or Org Admin can add a patient to another company."
      );
      return;
    }

    this.setState({ cloneToCompanyModalOpen: true });
  };

  closeCloneToCompanyModal = () => {
    this.setState({ cloneToCompanyModalOpen: false });
  };

  closeMergeHistoryModal = () => {
    this.setState({
      mergeHistoryModalOpen: false,
      mergeHistoryEmployeeId: null,
    });
  };
  addEmployeeToogleHandler = () => {
    this.setState({ isModelOpen: !this.state.isModelOpen,addEmployeeAutoFillData:{} });
  };

  render() {
    const {
      tableRecords,
      filters,
      isModelOpen,
      isDetailViewOpen,
      detailViewId,
      // isActiveDataLoaded,
      isDependentModelOpen,
      addEmployeeAutoFillData
      // company,
      // clinic_id
    } = this.state;
    const role = String(this.props.profile?.role || "").toLowerCase();
    const canCloneToCompany =
      role === "global_admin" || role === "organization_admin";
    // console.log('addEmployeeAutoFillData',addEmployeeAutoFillData);
    // Add a GlobalSearchFilter paths
    const globalSearchFilter = [
      "/visits",
      "/appointments",
      "/white-board",
      "/labs",
      "/result/vaccine",
      "/result/physical-drug-screens",
      "/employee",
    ];
    const { profile, location, isNewUI } = this.props;
    const { pathname } = location;
  
    return (
      <>
        {isModelOpen ? (
          <AddEmployee
            modelTitle={"Add Employee"}
            fetchEmployeeList={this.fetchEmployeeList}
            isOpen={this.state.isModelOpen}
            autoEmployeeFillData={addEmployeeAutoFillData}
            modalToogleHandler={this.addEmployeeToogleHandler}
            companiesOptions={this.state.companiesOptions}
          />
        ) : isDetailViewOpen ? (
          <EmployeeDetails
            modalToogleHandler={this.detailViewModal}
            fetchEmployeeList={this.fetchEmployeeList}
            employeeId={detailViewId}
            company_id={this.state.company_id}
            clinic_id={this.state.clinic_id}
            Toast={this.props.Toast}
            Loader={this.props.Loader}
          />
        ) : (
          <></>
        )}
        {
          isDependentModelOpen?
          <AddDependents
          employeeId={detailViewId}
          fetchEmployeeList={this.fetchEmployeeList}
          addFormHandler={this.addDependentToogle}
          />
          :
          ''
        }
        {
          this.state.inviteModalOpen?
          <SendInviteLinkModal
          modleToogleHandler={this.inviteToogleHandler}
          />
          :
          ''
        }
         {
          this.state.scanBarcodeModalOpen &&
          <ScanbarCodePopup
            modleToogleHandler={this.scanBarcodeHandler}
          />
        }
        {this.state.sendTaskModalOpen && (
          <SendTaskModal
            isOpen={this.state.sendTaskModalOpen}
            modalToogleHandler={() => this.setState({ sendTaskModalOpen: false, selectedNavigationLink: null })}
            Toast={this.props.Toast}
            Loader={this.props.Loader}
            navigationLink={this.state.selectedNavigationLink}
          />
        )}
        {this.state.mergeChartsModalOpen && (
          <MergeChartsContainer
            modalToogleHandler={() => this.setState({ mergeChartsModalOpen: false })}
            Toast={this.props.Toast}
            Loader={this.props.Loader}
            navigate={this.props.navigate}
            onMergeComplete={() => {
              this.setState({ mergeChartsModalOpen: false });
              this.fetchEmployeeList();
            }}
          />
        )}

        {this.state.cloneToCompanyModalOpen && (
          <CloneToCompanyModal
            show={this.state.cloneToCompanyModalOpen}
            profile={this.props.profile}
            Toast={this.props.Toast}
            onClose={this.closeCloneToCompanyModal}
            onCloneSuccess={() => {
              this.closeCloneToCompanyModal();
              this.fetchEmployeeList();
            }}
          />
        )}

        {this.state.mergeHistoryModalOpen && (
          <Modal
            show={this.state.mergeHistoryModalOpen}
            onHide={this.closeMergeHistoryModal}
            size="lg"
            dialogClassName="hResponsive modal-dialog-centered"
            contentClassName="merge-refined"
          >
            <div className="sh_modalBox merge-history-modal merge-refined">
              <Modal.Header closeButton className="merge-refined-header border-0 pb-0">
                <Modal.Title>
                  <h5 className="mb-0 merge-refined-title">Merge History</h5>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="merge-refined-body merge-history-body pt-0">
                <MergeHistoryViewer
                  employeeId={this.state.mergeHistoryEmployeeId}
                  onClose={this.closeMergeHistoryModal}
                  onRollbackComplete={() => {
                    this.closeMergeHistoryModal();
                    this.fetchEmployeeList();
                  }}
                />
              </Modal.Body>
              <Modal.Footer className="merge-refined-footer border-top py-3">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={this.closeMergeHistoryModal}
                >
                  Close
                </button>
              </Modal.Footer>
            </div>
          </Modal>
        )}

        <AuditLogPopup
          open={this.state.showAuditLogModal}
          subjectId={this.state.selectedAuditLogUserId}
          subjectLabel="Employee ID"
          subjectFilterKey="patient_id"
          onClose={() => this.auditLogModalHandler(null)}
          Toast={this.props.Toast}
          Loader={this.props.Loader}
        />

        <div className="sh_cardBox">
          <div className="sh_cardHeader pb-0">
              <div className="d-flex flex-column">
                <div className="d-flex position-relative">
                  {/* <h2 className="h2-strong position-absolute sh_welcome-text ">Employees List</h2> */}
                  {isNewUI && 
              profile &&
              profile.is_multiple_organization === false &&
              profile.employee_login === false &&
              globalSearchFilter.some((path) => pathname.startsWith(path)) && (
                <>
              <GlobalSearch
                  activeMenu={"Patients"}
                  pathname={pathname}
                  onPatientSelect={this.handlePatientSelect}
                  profile={profile}
              />
               <h2 className="h2-strong position-absolute sh_welcome-text ">Employees List</h2>
              </>
          )}
                </div>
              </div>
          </div>
            <div className="sh_cardHeader  sh_cardbglight p-1">
              <div className="form-group d-flex mb-0 app-heading-tab justify-content-between align-items-center app-heading-md">
                {/* <h6 class="text-lg f-500 mb-0"> Employee/Patient List </h6> */}
                <div className="app-header-tab">
                  <div className="tabs_wrapForTable pr-2">
                    <ul
                      class="nav nav-borders nav-tabs border-0"
                      role="tablist"
                    >
                      <li>
                        <a
                          class={`flex-sm-fill text-sm-center nav-link ${
                            this.state.isActiveDataLoaded ? "active" : ""
                          }`}
                          aria-current="page"
                          onClick={() => this.activeFilter(true)}
                          href="#"
                        >
                          Active Employee
                        </a>
                      </li>
                      <li>
                        <a
                          class={`flex-sm-fill text-sm-center nav-link  ${
                            this.state.isActiveDataLoaded ? "" : "active"
                          } `}
                          href="#"
                          onClick={() => this.activeFilter(false)}
                        >
                          In-Active Employee
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="d-flex ml-3 mt-1 filteropen_header">
                  <div className="form-group-fields row mr-2">
                    <div className="col-12 px-1 d-flex">
                      {/* <div className="input-group input-group-joined input-group-solid"></div> */}
                      <div className="d-flex sh_filter_formheader">
                      <div className="d-flex p-1">
                        <div className="btn-group pl-2">
                       {/* <div><Buttons
                          clickHandler={this.filterOnClick}
                          className="btn btn-outline-secondary mr-2"
                          acl={"any"}
                          label={"Search by "}
                          iconType={"Filter"}
                        ></Buttons></div>  */}
                      </div>
                       <div>
                          <FormInputs
                            placeholder="Employee"
                            value={filters["search_query"]}
                            changeHandler={(val) =>
                              this.onChangeFiltersHandler("search_query", val)
                            }
                            className="form-control"
                          />
                        </div>
                        </div>
                        <div className="d-flex">                           
                      <div className="addAction mr-2">
                      <div className="btn-group p-1">
                            <button
                              className="btn btn-primary"
                              onClick={() => this.submitFiltersHandler()}
                            >
                              Search
                            </button>
                            <button
                              className="btn btn-outline-secondary"
                              onClick={() => this.clearFiltersHandler()}
                            >
                              Clear
                            </button>
                          </div>
                        <div className="btn-group pl-2">
                          <Buttons
                            clickHandler={this.addEmployeeToogleHandler}
                            className="btn btn-primary"
                            // appendAddIcon={true}
                            acl={"employee-create"}
                            label={"Add Patient"}
                          />
                        
                      </div>
                      <div className="btn-group pl-1">
                        <Buttons
                          clickHandler={() => this.setState({ mergeChartsModalOpen: true })}
                          className="btn btn-primary"                          acl={PERMISSIONS.MERGE_PATIENT.CREATE}
                          label={"Merge Charts"}
                          iconType={"Merge"}
                        />
                      </div>
                      {canCloneToCompany ? (
                      <div className="btn-group pl-1">
                        <Buttons
                          clickHandler={this.openAddToAnotherCompanyHandler}
                          className="btn btn-primary"
                          label={"Add Patient to Another Company"}
                          title="Select a patient, then choose target company"
                        />
                      </div>
                      ) : null}
                      <div className="btn-group pl-1">
                      <Buttons
                            clickHandler={this.inviteToogleHandler}
                            className="btn btn-primary"
                            // appendAddIcon={true}
                            acl={"employee-invite_patient"}
                            accessType="Hide"
                            label={"Invite Patient"}
                          />
                          </div>
                          <div className="btn-group">
                          <Buttons
                            clickHandler={this.scanBarcodeHandler}
                            className="btn btn-primary ml-1"
                            acl={"employee-scan_barcode"}
                            accessType="Hide"
                            label={"Scan Barcode"}
                          />
                          </div>
                          </div>

                      </div>
                      </div>
                    </div>
                  </div>
                  
                  
                </div>
              </div>
            </div>

            <div className="sh_cardBody sh_cardbglight p-0">
              <TableGrid
                hasPagination={true}
                fetchTableRecords={(filters) => this.fetchEmployeeList(filters)}
                hasHeaderAction={true}
                headersProps={{
                  tableRecords: tableRecords,
                  headerButtons: this.getHeaderButtons(),
                  checkBoxchangeHandler: this.checkBoxchangeHandler,
                }}
                {...tableRecords}
              />
            </div>
          </div>
         
        {/* </TableSkeleton> */}

        {this.state.filterOpen ? (
          <>
            {ReactDOM.createPortal(
              <EmployeeFilter
                onChangeHandler={this.onChangeFiltersHandler}
                filterData={this.state.filters}
                closeHandler={this.filterCloseHandler}
                submitHandler={this.submitFiltersHandler}
                companiesOptions={this.state.companiesOptions}
              />,
              document.getElementById("sh_mainportal_view") // Render the component into the portal container
            )}
          </>
        ) : (
          ""
        )}
      </>
    );
  }
  submitFiltersHandler = async () => {
    const { filters } = this.state;
    let filter = {};
    this.state.isActiveDataLoaded ? (filter = { active: true }) : (filter = { inactive: true });
  
    await this.fetchEmployeeList({ ...filters, ...filter });
  };
  
  clearFiltersHandler = ()=>{
    this.setState({
      filters: {
        ...this.state.filters,
        search_query:'',    
      },
    },this.submitFiltersHandler);
  };
  
  fetchEmployeeList = async (query = '') => {
    try {
      if (query=='') {
        this.state.isActiveDataLoaded?query={active:true}:query={inactive:true};
      }
      const globalFilter=this.props?.globalFilter?.Chart || {};
      query={...query,...globalFilter}

      const canShowAuditLog =acl_check(this.props?.profile?.permissions, PERMISSIONS.AUDIT_LOG.LIST);

      this.props.Loader(true);
      const EmployeeList = await EmployeeService.getEmployeeList(query);
      let tableData = [];
      EmployeeList.data.data.forEach((employee, employeeIndex) => {
        const patientParams = encryptString({
          patientName:(employee.first_name+' '+employee.last_name+' '+employee.dob),
          company_id:employee.company_id,
          company_assigned:employee.company_assigned,
          employee_id:employee.employee_id,
        });
        tableData = [
          ...tableData,
          {
            employeeIndex: 0,
            isHeading: false,
            rowId: employee.employee_id,
            data: {
              isActive: false,
              first_name: employee.first_name,
              last_name: employee.last_name,
              dob: employee.dob,
              gender: employee.gender,
              phone:formatPhoneNumberUS(employee.phone) || "--",
              company: isSet(employee.company) ? employee.company.name : '-- Company Need to Assigned --',
              created_at: employee.created_at,
              updated_at: employee.updated_at,
              status: employee.status?"Active":'InActive',
              action: [
                {
                  className: "btn btn-icon btn-transparent-dark",
                  iconType: "Search",
                  label: "",
                  acl: "employee-edit",
                  title: "Detail view",
                  clickHandler: () =>
                    this.detailViewModal(employee.employee_id,employee.company_id,employee.clinic_id),
                },
                // {
                //   className: "",
                //   iconType: "UserGroup",
                //   label: "",
                //   acl: "employee-edit",
                //   title: "Dependents",
                //   clickHandler: () =>
                //     this.addDependentToogle(employee.employee_id),
                // },
                // {
                //   className: "btn btn-icon btn-transparent-dark",
                //   iconType: "History",
                //   iconSize: 15,
                //   label: "",
                //   acl: PERMISSIONS.EMPLOYEE.MERGE_CHARTS,
                //   title: "View Merge History",
                //   clickHandler: () =>
                //     this.viewMergeHistory(employee.employee_id),
                // },
                {
                  className: "btn btn-icon btn-transparent-dark",
                  iconType: "VisitHistory",
                  acl:PERMISSIONS.EMPLOYEE.VISIT_HISTORY,
                  accessType:"Hide",
                  iconSize: 15,
                  label: "",
                  // acl: PERMISSIONS.VISITS.LIST,
                  title: "Visits History",
                  // href: acl_check(this.props.profile.permissions,PERMISSIONS.VISITS.LIST)
                  //   ? (this.props.profile?.role === 'employer_admin' 
                  //       ? `/employer-employee/visit-history/${employee.employee_id}/${patientParams}`
                  //       : `/employee/visit-history/${employee.employee_id}/${patientParams}`)
                  //   : ''
                  href: this.props.profile?.role === 'employer_admin' 
                    ? `/employer-employee/visit-history/${employee.employee_id}/${patientParams}`
                    : `/employee/visit-history/${employee.employee_id}/${patientParams}`
                },
                // {
                //   className: "btn btn-datatable btn-icon btn-transparent-dark",
                //   iconType: "Edit",
                //   title: "Edit",
                //   type: "GridEdit",
                //   acl: "employee-edit",
                //   clickHandler: (rowId, data) => this.editHandler(rowId, data),
                //   updateHandler: () => this.updateHandler(employee.employee_id),
                //   onChangeFormDataInEdit: (key, val) =>
                //     this.onChangeFormDataInEdit(key, val),
                // },
                {
                  className: "btn btn-icon btn-transparent-dark",
                  iconType: "Remove",
                  acl: "employee-delete",
                  title: "Delete",
                  isDelete:true,
                  clickHandler: () => this.deleteHandler(employee.employee_id),
                },
                {
                  className: 'btn btn-icon btn-transparent-dark',
                  iconType: 'ChatSquareTextFill',
                  acl: PERMISSIONS.EMPLOYEE.SEND_MESSAGE,
                  accessType: 'Hide',
                  title: 'Send Message',
                  clickHandler: () => {
                    const patientParams = encryptString({
                      patientName: `${employee.first_name || ''} ${employee.last_name || ''}`.trim(),
                      company_id: employee.company_id || '',
                      company_assigned: employee.company_assigned || '',
                      employee_id: employee.employee_id,
                    });
                    const visitHistoryUrl = this.props.profile?.role === 'employer_admin' 
                      ? `/employer-employee/visit-history/${employee.employee_id}/${patientParams}`
                      : `/employee/visit-history/${employee.employee_id}/${patientParams}`;
                    this.sendTaskModalHandler(visitHistoryUrl);
                  }
                },
                ...(canShowAuditLog
                  ? [
                      {
                        className: 'btn btn-icon btn-transparent-dark',
                        iconType: 'AuditLog',
                        acl: PERMISSIONS.AUDIT_LOG.LIST,
                        title: 'Audit Log',
                        clickHandler: () =>
                          this.auditLogModalHandler(employee.employee_id),
                      },
                    ]
                  : []),
              ],
            },
          },
        ];
      });
      const updatePagination = (prevStatePagination, newPagination) => ({
        page: newPagination.page || prevStatePagination.page,
        perPage: newPagination.perPage || prevStatePagination.perPage,
        totalRecords: EmployeeList.pagination.totalCount,
        sort_by: newPagination.sort_by || prevStatePagination.sort_by,
        sort_order: newPagination.sort_order || prevStatePagination.sort_order,
      });
      this.setState((prevState) => ({
        tableRecords: {
          ...prevState.tableRecords,
          tableHeaders: prevState.tableRecords.tableHeaders,
          tableRows: {
            type: "default",
            data: tableData,
          },
          pagination: {
            ...prevState.tableRecords.pagination,
            ...updatePagination(prevState.tableRecords.pagination, query),
          },
        },
      }));
      this.props.Loader();
    } catch (e) {
      this.props.Loader();
    }
  };

  getHeaderButtons = () => {
    return [
      {
        className: "btn btn-icon btn-transparent-dark ml-1",
        iconType: "Download",
        title: "Print Demographics",
        label: null,
        acl: "any",
        clickHandler: this.handlePrintDemographyBulk,
      },
    ];
  };

  /**
   * Handle bulk Patient Demography print for selected employees.
   * @param {string} employeeIds Comma separated employee_id list or 'ALL'
   */
  handlePrintDemographyBulk = async (employeeIds) => {
    try {
      const { tableRecords } = this.state;
      let ids = [];
      if (employeeIds === 'ALL') {
        ids = tableRecords.tableRows.data.map((row) => row.rowId);
      } else if (typeof employeeIds === 'string') {
        ids = employeeIds.split(',').map((id) => id.trim()).filter(Boolean);
      }
      if (!ids.length) {
        if (this.props.Toast) {
          this.props.Toast.error('No patients selected to print demographics');
        }
        return;
      }
      if (this.props.Loader) this.props.Loader(true);
      const base64Data = await EmployeeService.printEmployeesDemography(ids);
      if (base64Data && typeof base64Data === 'string' && base64Data.length > 0) {
        const pdfData = {
          file_content: base64Data,
          original_name: 'PatientDemographics',
          mime_type: 'application/pdf',
        };
        const FileManagerService = (await import('../../services/FileManagerService')).default;
        FileManagerService.printPdf(pdfData);
      } else if (this.props.Toast) {
        this.props.Toast.error('Failed to generate Patient Demographics PDF');
      }
    } catch (error) {
      console.error('Bulk print demographics error', error);
      if (this.props.Toast) {
        this.props.Toast.error('Error printing Patient Demographics PDF');
      }
    } finally {
      if (this.props.Loader) this.props.Loader(false);
    }
  };
  detailViewModal = (empId,companyId="",clinicId="") => {
    this.setState((oldState) => ({
      isDetailViewOpen: !oldState.isDetailViewOpen,
      detailViewId: empId,
      company_id:companyId,
      clinic_id:clinicId
    }));
  };
  deleteHandler = async (employeeId) => {
      try {
        let respons=await EmployeeService.deleteEmployee(employeeId);
        if(isSet(respons)&&respons.status=="ERROR" &&respons.data){
          this.props.Toast.error(respons.data);
        }else{
            this.props.Toast.success('Employee Deleted Successfully');
            this.fetchEmployeeList();
        }
      } catch (e) {}
  };
  editHandler = (rowId, data) => {
    // console.log("rowId",rowId,"data",data);
    if (rowId == null) {
      this.setState({ activeEditId: "", formDataInEdit: {} });
      return false;
    }
    this.setState({
      activeEditId: rowId,
      formDataInEdit: data,
    });
  };
  onChangeFiltersHandler = (key, val) => {
    const { filters } = this.state;
    this.setState({
      filters: {
        ...filters,
        [key]: val,
      },
    });
  };
  addDependentToogle=(employee_id='')=>{
    this.setState({isDependentModelOpen:!this.state.isDependentModelOpen,detailViewId:employee_id});
  }
  inviteToogleHandler=()=>{
    this.setState({inviteModalOpen:!this.state.inviteModalOpen});
  }
  scanBarcodeHandler=(obj={},isAddEmployee=false)=>{
    this.setState({
      scanBarcodeModalOpen:!this.state.scanBarcodeModalOpen,
      addEmployeeAutoFillData:obj,
      isModelOpen:isAddEmployee
    });
  }

  checkBoxchangeHandler = (value, { e }, rowId = "") => {
    if (!rowId) {
      rowId = e?.target?.id;
    }
    const { tableRows } = this.state.tableRecords;
    const boolValue = value === 1 || value === true;
    let updatedData;

    if (rowId === "ALL") {
      updatedData = tableRows.data.map((item) => {
        item.data.isActive = boolValue;
        return item;
      });
      this.props.setActiveIds(boolValue ? updatedData.map((item) => item.rowId) : []);
      if (!boolValue) this.props.setSelectedAllRecords(false);
    } else {
      updatedData = tableRows.data.map((item) => {
        if (item.rowId === rowId) item.data.isActive = boolValue;
        return item;
      });
      const activeIds = updatedData
        .filter((item) => item.data.isActive === true || item.data.isActive === 1)
        .map((item) => item.rowId);
      this.props.setActiveIds(activeIds);
      if (
        !updatedData.every(
          (item) => item.data.isActive === true || item.data.isActive === 1
        )
      ) {
        this.props.setSelectedAllRecords(false);
      }
    }

    const allSelected =
      updatedData.length > 0 &&
      updatedData.every(
        (item) => item.data.isActive === true || item.data.isActive === 1
      );
    const allCheckbox = document.getElementById("ALL");
    if (allCheckbox) allCheckbox.checked = allSelected;

    this.setState((prevState) => ({
      tableRecords: {
        ...prevState.tableRecords,
        tableRows: {
          data: updatedData,
        },
      },
    }));
  };
  filterOnClick = () => {
    this.setState({
      filterOpen: !this.state.filterOpen,
    },()=>{
      if (document.body.classList.contains('filterOpened')) {
        document.body.classList.remove('filterOpened');
        // menuToggleElement.removeClass('active');
      } else {
        document.body.classList.add('filterOpened');
      }
    });
  };
  filterCloseHandler = (isClear=true) => {
    if (isClear) {
      this.setState({
        filters: {
          ...this.state.filters,
          first_name: "",
          last_name: "",
          gender: "",
          company_id: "",
          dob: "",
          patient_id: "",
          phone: "",
          patient_id: "",
          identification_type: "",
          identification_number: "",
          clinic_id: "",
          booking_id: "",
          pre_registration_code: "",
        },
      },this.submitFiltersHandler);
    }
    else{
      this.setState({
        filterOpen: false,
      },()=>{
        if (document.body.classList.contains('filterOpened')) {
          document.body.classList.remove('filterOpened');
          // menuToggleElement.removeClass('active');
        } else {
          document.body.classList.add('filterOpened');
        }
      });
    }
    
  };
  sendTaskModalHandler = (navigationLink = null) => {
    this.setState({
      sendTaskModalOpen: true,
      selectedNavigationLink: navigationLink,
    });
  };

  auditLogModalHandler = (employeeId) => {
    const isOpening = !this.state.showAuditLogModal;

    if (isOpening) {
      this.setState({
        showAuditLogModal: true,
        selectedAuditLogUserId: employeeId,
      });
      return;
    }

    this.setState({
      showAuditLogModal: false,
      selectedAuditLogUserId: null,
    });
  };

  activeFilter=(status)=>{
    let filters={};
    if (status) {
       filters={
        active:true,
      };
      this.setState({
        isActiveDataLoaded:true
      })
    }
    else{
      filters={
        inactive:true
      }
      this.setState({
        isActiveDataLoaded:false
      })

    }
    this.fetchEmployeeList(filters);
  }
}
const mapStateToProps = (state) => ({
  activeIds: state.globalFilter?.checkbox?.cbActiveIds || [],
  selectedAllRecords: state.globalFilter?.checkbox?.cbSelectedAllRecords || false,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedAllRecords: (payload) => dispatch(setSelectedAllRecords(payload)),
  setActiveIds: (payload) => dispatch(setActiveIds(payload)),
  clearCbState: () => dispatch(clearCbState()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withReduxState(WithRoutify(EmployeeList)));